import { ReplacerObject } from '../../MyStichtingOpenHelpers/src'
import Head from 'next/head'
import { DictionaryContext } from '../../MyStichtingOpenComponents/src/providers'
import { APP_NAME, PAGE_TITLE_SEPARATOR, PageTitle, STICHTING_OPEN } from '../constants/messageConstants'
import { useContext } from 'react'

const FALLBACK_TITLE = 'Stichting Open'

interface Props {
    //  * @param key The dictionary key to fetch
    pageTitle: PageTitle
    //  * @param replacer Optional object containing key-value pairs to replace placeholders in the translation
    replacer?: ReplacerObject
}
export const PageTitleComponent = ({ pageTitle, replacer }: Props) => {
    const { getText } = useContext(DictionaryContext)
    const titleSections = [getText(pageTitle, replacer), getText(APP_NAME), getText(STICHTING_OPEN)]
    const separator = getText(PAGE_TITLE_SEPARATOR)
    const title = titleSections.filter((section) => section.length).join(separator?.length ? ` ${separator} ` : ' - ')

    return (
        <Head>
            <title>{title.length ? title : FALLBACK_TITLE}</title>
        </Head>
    )
}
